import KakaoMap from "../../module/kakao_map/kakao_map";
import Delimiter from "../../util/delimiter";
import "./roadmap_page.css";

function RoadmapPage() {
  return (
    <div className="roadmap_page">
      <div className="roadmap_container">
        <KakaoMap />
      </div>
      <div className="address_container">
        <span>주소</span>
        <Delimiter />
        <span>충남 천안시 서북구 월봉7길 49 2층 223호</span>
      </div>
    </div>
  );
}

export default RoadmapPage;
